module.exports = __webpack_public_path__ + "static/media/vinicius-almeida.35d279d3.png";